module.exports = __webpack_public_path__ + "static/media/statisical.e83d6942.png";